import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function updateOrgName(name) {
  try {
    loginfo();
    return await apiClient.post('/updateOrganizationName', {
      newOrganizationName: name,
    });
  } catch (error) {
    console.error('updateOrgName failed.', error);
  }
}

export async function getOrgName() {
  try {
    const res = await tryCache('getOrgName', () => apiClient.get('/getOrganizationName'));
    return res;
  } catch (error) {
    console.error('getOrgName failed.', error);
  }
}

export async function getWorkplaceMembers(accessLevels) {
  try {
    loginfo();
    return await apiClient.post('/getAllFusionMembers', {
      permissionLevel: accessLevels,
    });
  } catch (error) {
    console.error('getAllFusionMembers failed.', error);
  }
}

export async function getAuditLogs(pageIndex, PAGE_LENGTH, query, sortKey, sortOrder) {
  try {
    let offsetAmount = (pageIndex - 1) * PAGE_LENGTH;

    if (offsetAmount < 0) {
      offsetAmount = 0;
    }

    const res = await tryCache(
      `getAuditLogs-${pageIndex}-${PAGE_LENGTH}-${query || ''}-${sortKey}-${sortOrder}`,
      () =>
        apiClient.post('/getAuditLogs', {
          index: pageIndex,
          batchSize: PAGE_LENGTH,
          offset: pageIndex * PAGE_LENGTH,
          searchTerm: query,
          orderBy: sortKey,
          orderDir: sortOrder,
        }),
    );
    return res;
  } catch (error) {
    console.error('getAuditLogs failed.', error);
  }
}
